import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  error: {state: false, message:"", ts: null},
  info: {state: false, message:"", ts: null},
  success: {state: false, message:"", ts: null},
  messages: [],
  //this is an array of array of a user's different messages sessions
  allMessagesArray: [],
  userResumesAll: [],
  user: {},
  userFirstName: "",
  resume: {},
  email: "",
  meeting: {},
  pricingDetails: {},
  hideCards: false,
  transcriptActivityStarted: false,
  fetching: false,
  showCheckout: false,
  resumeSubDuration: "",
  isResumeSubbed: false,
  examSubDuration: "",
  isExamSubbed: false,
  resumeServicesNumbers: {
    resumeCreated: 0,
    jobsApplied: 0,
    coverLettersCreated: 0,
    interviewMocks: 0,
    followUpEmails: 0,
    jobConnectionRefresh: 0
  },
  examDetails: {},
  profileImg: "",
  // Centralized notifications state
  notifications: {
    items: [],
    unreadCount: 0,
    lastFetched: 0,
    loading: false,
  },
  testimonials: {
    items: [],
    lastFetched: 0,
    loading: false,
  },
}

export const stateSlice = createSlice({
  name: 'messagesState',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    setInfo: (state, action) => {
      state.info = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    //For when user logs in, set messages from server
    setMessages: (state, action) => {
      const newArray = [...action.payload];
      state.messages = newArray
    },
    //For when user logs in set all messages array of arrays from server
    setAllMessagesArray: (state, action) => {
      const newArrays = [...action.payload];
      state.allMessagesArray = newArrays
    },
    //Add new message session array
    // setNewSessionArray: (state, action) => {
    //   const newArray = action.payload
    //   state.allMessagesArray = [...state.allMessagesArray, newArray]
    // },
    setUserResumesAll: (state, action) => {
      const newArray = action.payload;
      state.userResumesAll = newArray
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUserFirstName: (state, action) => {
      state.userFirstName = action.payload;
    },
    //Set each message from user/assistant
    setMessage: (state, action) => {
      const newMessage = action.payload
      state.messages = [...state.messages, newMessage]
    },
    deleteLastMessage: (state) => {
      state.messages.splice(-1, 1)
    },
    setResume: (state, action) => {
      state.resume = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setMeeting: (state, action) => {
      state.meeting = action.payload;
    },
    setPricingDetails: (state, action) => {
      state.pricingDetails = action.payload;
    },
    setHideCards: (state, action) => {
      state.hideCards = action.payload;
    },
    setFetching: (state, action) => {
      state.fetching = action.payload;
    },
    setTranscriptActivityStarted: (state, action) => {
      state.transcriptActivityStarted = action.payload;
    },
    setShowCheckout: (state, action) => {
      state.showCheckout = action.payload
    },
    setResumeSubDuration: (state, action) => {
      state.resumeSubDuration = action.payload
    },
    setIsResumeSubbed: (state, action) => {
      state.isResumeSubbed = action.payload;
    },
    setExamSubDuration: (state, action) => {
      state.examSubDuration = action.payload;
    },
    setIsExamSubbed: (state, action) => {
      state.isExamSubbed = action.payload;
    },
    setResumeServicesNumbers: (state, action) => {
      state.resumeServicesNumbers = action.payload;
    },
    setExamDetails: (state, action) => {
      state.examDetails = action.payload;
    },
    setProfileImg: (state, action) => {
      state.profileImg = action.payload;
    },
    // Notifications reducers
    setNotificationsState: (state, action) => {
      const { items = [], unreadCount = 0, lastFetched = Date.now() } = action.payload || {};
      state.notifications.items = items;
      state.notifications.unreadCount = unreadCount;
      state.notifications.lastFetched = lastFetched;
    },
    setNotificationsLoading: (state, action) => {
      state.notifications.loading = Boolean(action.payload);
    },
    setNotificationsUnread: (state, action) => {
      state.notifications.unreadCount = Number(action.payload) || 0;
    },
    markAllNotificationsRead: (state) => {
      state.notifications.unreadCount = 0;
      state.notifications.items = state.notifications.items.map(n => ({ ...n, status: 'read' }));
    },
    prependNotification: (state, action) => {
      const item = action.payload;
      if (!item) return;
      // Avoid duplicates by _id if present
      const id = item._id;
      const exists = id ? state.notifications.items.some(x => x._id === id) : false;
      state.notifications.items = exists ? state.notifications.items : [item, ...state.notifications.items].slice(0, 100);
    },
    markNotificationRead: (state, action) => {
      const id = action.payload;
      if (!id) return;
      let dec = 0;
      state.notifications.items = state.notifications.items.map(n => {
        if (n._id === id && n.status !== 'read') { dec = 1; return { ...n, status: 'read' }; }
        return n;
      });
      if (dec) state.notifications.unreadCount = Math.max(0, (state.notifications.unreadCount || 0) - 1);
    },
    setTestimonialsState: (state, action) => {
      state.testimonials.items = action.payload;
      state.testimonials.lastFetched = Date.now();
      state.testimonials.loading = false;
    },
    setTestimonialsLoading: (state, action) => {
      state.testimonials.loading = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { 
    setError,
    setInfo,
    setSuccess,
    setMessages,
    setAllMessagesArray,
    // setNewSessionArray,
    setUserResumesAll,
    setUser,
    setMessage,
    deleteLastMessage,
    setResume,
    setEmail,
    setMeeting,
    setPricingDetails,
    setHideCards,
    setFetching,
    setTranscriptActivityStarted,
    setShowCheckout,
    setResumeSubDuration,
    setIsResumeSubbed,
    setExamSubDuration,
    setIsExamSubbed,
    setResumeServicesNumbers,
    setExamDetails,
    setProfileImg,
  setUserFirstName,
  // notifications actions
  setNotificationsState,
  setNotificationsLoading,
  setNotificationsUnread,
  markAllNotificationsRead,
  prependNotification,
  markNotificationRead,
  setTestimonialsState,
  setTestimonialsLoading,
} = stateSlice.actions

export default stateSlice.reducer